import React from "react";
import PochtaComponents from "../../components/pochta/PochtaComponents";
const Pochta = () => {
  return <PochtaComponents />
};

export default Pochta;
